import { toastService } from "../../../component/common/toast-messages/toast";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import Actions from "../../actions";
import * as requestFromServer from "./walletManagementApis";

// Wallet Management -> get Wallet Management  api
export const getWalletManagementAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.getWalletManagement(dataToBeSent);
  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_WALLET_MANAGEMENT_LIST, {
        walletManagement: response,
      })
    );
    return response;
  }
};

// wallet management -> add fund to wallet api
export const addFundToWalletAction =
  (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.addFundToWallet(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      navigate(baseRouteMakerForSuperAdmin(routes.WALLET_MANAGEMENT));
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
